import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getContent } from 'app/modules/cms/service/store/cms-selectors';
import { CmsPageContentType } from 'app/modules/cms/tools/types';
import { getDocumentPathFromOfferSku, getDocumentPathFromProductCode } from 'app/shared/util/method-util';
import { isNull } from 'lodash';
import React, { useState } from 'react';
import { Translate } from 'react-jhipster';
import { useSelector } from 'react-redux';
import { Collapse, Modal, ModalBody } from 'reactstrap';
import packageJson from '../../../../../../../../package.json';
import './mobile-options.scss';
import moment from 'moment';
import { IRootState } from 'app/shared/reducers';

const MobileOptions = ({ didomi, spbLogoUrl, offerSku, handleOpenDocument, languagesList, productCode }) => {

  const REACT_APP_VERSION = packageJson.version.replace('-SNAPSHOT', '');
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [collapse, setCollapse] = useState(false);
  const toggleCollapse = () => setCollapse(!collapse);

  const documentPath = productCode && getDocumentPathFromProductCode(productCode);
  const cmsContent = useSelector((state: IRootState) => state.cms.content)[CmsPageContentType.APP_GLOBAL_TYPE]
  const selectLangue = (language) => {
    localStorage.setItem('language', language);
    window.location.reload();
  }

  return (
    <>
      <div className="mobileOptionsIcon" onClick={() => toggle()}>
        <FontAwesomeIcon icon="ellipsis-v" size="lg" />
      </div>
      <Modal isOpen={modal} toggle={toggle} className="mobileOptionsPanel">
        <ModalBody>
          <ul>
            <li><a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/" + documentPath + "/LegalNotice.pdf", "Mentions légales")}>
            {cmsContent && cmsContent?.legalNotice}
            </a></li>
            <li><a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/" + documentPath + "/CharteConfidentialite.pdf", "Charte de confidentialité")}>
            {cmsContent && cmsContent?.privacyPolicy}
            </a></li>
            <li><a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/" + documentPath + "/CGU.pdf", "CGU")}>
            {cmsContent && cmsContent?.termsOfService}
            </a></li>
            <li><a onClick={() => didomi.preferences.show()} style={{ cursor: 'pointer' }} >
            {cmsContent && cmsContent?.cookieManagement}
            </a></li>
            <li onClick={toggleCollapse}>
              <Translate contentKey="form.mobile.burgerMenu.languages.name"></Translate>
              <Collapse isOpen={collapse}>
                <ul className="languageList">
                  {languagesList.map((language, key) => {
                    return <li key={key} onClick={(e) => selectLangue(language.toLowerCase())}>
                      {language}
                      <img className="flags" src={"/content/images/flags/" + language + ".svg"} />
                    </li>
                  })}
                </ul>
              </Collapse>
            </li>
            <div>
              <div className="spb-menu-version">
                Copyright © {moment().format('YYYY')} version : {REACT_APP_VERSION}
              </div>
              {!isNull(spbLogoUrl) && <img alt="cover" className="spbLogo" src={spbLogoUrl} />}
            </div>
          </ul>
        </ModalBody>
      </Modal>
    </>
  );
}

export default MobileOptions;
